export const IBIS_ID_ADDIN_ID = "a2JiM2RlN2EtZTFmOC1lNDV";

export interface IbisIdData {
  userId: string;
  value: string;
}
